export default "__VITE_ASSET__d4002c34__"